import { MedicalType } from "@qendo/medical/types";
import { useLocalSearchParams } from "expo-router";
import { ConditionForm } from "~/components/form/health-profile/ConditionForm";
import { Authorize } from "~/components/permission/Authorize";
import { Dismiss } from "~/components/permission/Dismiss";
import { useDismiss } from "~/providers/DismissProvider";
import { useMedical } from "~/providers/MedicalProvider";

const type = MedicalType.condition;

export default function EditCondition() {
    const { id }: { id: string } = useLocalSearchParams();
    const { findMedical } = useMedical();
    const { handleDismiss } = useDismiss();
    const condition = findMedical(type, id);

    if (!condition) {
        return <Dismiss />;
    }

    return (
        <Authorize ability="update" section="conditions">
            <ConditionForm condition={condition} onRequestClose={handleDismiss} asRoute />
        </Authorize>
    );
}
